import { useEffect } from "react"
import { get } from '@util/xhrAPI'
import { useSelector, useDispatch } from 'react-redux'
import { fullUpdate } from '@store/slice/dashboardSlice'
import { Chart } from 'react-google-charts'
import { useTranslation } from 'react-i18next'
import Div from '@ui/layout/Div'

const GlobalVueDashboard = () => {
  const { mission } = useSelector(state => state.main)
  const { missionSubjects } = mission
  const missionSubjectConfig = missionSubjects[0]?.config
  const { data } = useSelector(state => state.dashboard)
  const [t] = useTranslation('common')
  const dispatch = useDispatch()

  const renderMonthlyCallsEvolutionLineChart = () => {
    const yearlyEvolution = data['yearlyEvolution']
    if ('undefined' === typeof yearlyEvolution) {
      return <></>
    }
    let statsYearlyEvolution = [
      [t('labels.years'), t('labels.calls')]
    ]
    const years = Object.keys(yearlyEvolution)

    const yearlyEvolutionData = years.map(year => {
      return [year, yearlyEvolution[year] ?? 0]
    })

    statsYearlyEvolution = [...statsYearlyEvolution, ...yearlyEvolutionData]

    const optionsYearlyEvolution = {
      title: t('titles.monthly_line_calls_evolution'),
      curveType: "function",
      legend: { position: "bottom" },
    };
    return (
      <Chart
        chartType="LineChart"
        data={statsYearlyEvolution}
        options={optionsYearlyEvolution}
        width={"100%"}
        height={"400px"}
        legendToggle
      />
    );
  }

  const renderScanTreatmentTable = () => {
    const treatmentData = data['treatmentData']
    if ('undefined' === typeof treatmentData) {
      return <></>
    }

    const getScanData = () => {
      const scanRows = Object.keys(treatmentData).map(key => {
        return (
          <tr key={`${key}-scan-data`}>
            <td>{key}</td>
            {
              missionSubjectConfig.withEggs
                ? <>
                  <td>{treatmentData[key]['total']['totalNests']}</td>
                  <td>{treatmentData[key]['total']['totalTreatedNests']}</td>
                  <td>{treatmentData[key]['total']['totalNonTreatedNests']}</td>
                  <td>{treatmentData[key]['total']['totalEmptyNests']}</td>
                  <td>{treatmentData[key]['total']['totalBirds']}</td>
                  <td>{treatmentData[key]['total']['totalEggs']}</td>
                  <td>{treatmentData[key]['total']['totalTreatedEggs']}</td>
                  <td>{treatmentData[key]['total']['totalNonTreatedEggs']}</td>
                  <td>{treatmentData[key]['total']['failedSterilizationEggs']}</td>
                </>
                : <>
                  <td>{treatmentData[key]['total']['totalNests']}</td>
                  <td>{treatmentData[key]['total']['totalTreatedNests']}</td>
                  <td>{treatmentData[key]['total']['totalNonTreatedNests']}</td>
                </>
            }
          </tr>
        )
      })
      return scanRows
    }

    return (
      <Div cssClass='column is-12'>
        <h3>{t('table.scans_resume')}</h3>
        <table className='table is-fullwidth is-hoverable is-bordered'>
          <thead>
            <tr>
              <th>{t('table.year')}</th>
              {
                missionSubjectConfig.withEggs
                  ? <>
                    <th>{t('table.total_nests')}</th>
                    <th>{t('table.treated_nests')}</th>
                    <th>{t('table.nb_non_treated_nests')}</th>
                    <th>{t('table.nb_empty_nests')}</th>
                    <th>{t('table.nb_birds')}</th>
                    <th>{t('table.total_eggs')}</th>
                    <th>{t('table.nb_treated_eggs')}</th>
                    <th>{t('table.nb_non_treated_eggs')}</th>
                    <th>{t('table.nb_failed_eggs_sterilization')}</th>
                  </>
                  : <>
                    <th>{t('table.total_nests')}</th>
                    <th>{t('table.found_nests')}</th>
                    <th>{t('table.nb_non_treated_nests')}</th>
                  </>
              }
            </tr>
          </thead>
          <tbody>
            {getScanData()}
          </tbody>
        </table>
      </Div>
    )
  }

  useEffect(() => {
    if (null === data) {
      get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/dashboard`, response => {
        const { errors, data } = response
        dispatch(fullUpdate({ errors, data }))
      })
    }
  }, [])

  return (
    <>
      {
        null !== data
          ?
          <Div cssClass='dashboard-global columns is-multiline'>
            <Div cssClass='charts column is-12'>
              <Div cssClass='columns is-multiline'>
                {renderScanTreatmentTable()}
              </Div>
            </Div>
            <Div cssClass='charts column is-12'>
              {renderMonthlyCallsEvolutionLineChart()}
            </Div>
          </Div>
          : <></>
      }
    </>
  )
}

export default GlobalVueDashboard